import { Box, Typography } from '@mui/material';

import caution from '../../assets/icons/caution.svg';

const signs = [
  '1. O processo não poderá continuar sem crédito disponível.',
  '2. Sem limite disponível agora. Experimente consultar novamente no futuro.',
];

const NoLimitIndicator = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column' },
        px: { xs: '14px', md: '52px' },
        pt: { xs: '20px', md: '80px' },
        pb: { xs: '20px', md: '16px' },
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: { xs: 'column' },
          mb: { xs: '24px', md: '80px' },
          px: { xs: '20px', md: '150px', lg: '300px' },
          width: { lg: '1106px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'start',
            alignItems: 'center',
            gap: { xs: '0px', md: '40px' },
            mb: { md: '40px' },
          }}
        >
          <Box
            component="img"
            src={caution}
            alt="Caution Icon"
            sx={{
              height: { xs: '88px', md: '104px' },
              width: { xs: '102px', md: '120px' },
              marginBottom: { xs: '24px', md: '16px' },
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: '20px', md: '24px' },
              textAlign: { xs: 'center', md: 'left' },
              fontWeight: 700,
              color: '#FF0000',
              fontFamily: 'Montserrat, sans-serif',
              marginBottom: { xs: '16px', md: '0px' },
            }}
          >
            Não encontramos limite de crédito disponível.
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: { xs: '14px' },
            textAlign: { xs: 'center' },
            fontWeight: 400,
            color: '#808080',
            fontFamily: 'Montserrat, sans-serif',
            marginBottom: '32px',
          }}
        >
          Infelizmente não identificamos um limite de crédito pré-aprovado para
          o CNPJ informado. Isso pode acontecer por diversos motivos.
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '14px' },
            textAlign: { xs: 'center', md: 'left' },
            fontWeight: 700,
            color: '#808080',
            fontFamily: 'Montserrat, sans-serif',
            marginBottom: '16px',
          }}
        >
          O que isso significa?
        </Typography>
        <Box
          sx={{
            px: { md: '60px' },
          }}
        >
          {signs.map((sign) => (
            <Typography
              key={sign}
              sx={{
                fontSize: { xs: '14px' },
                textAlign: 'center',
                fontWeight: 400,
                color: '#808080',
                fontFamily: 'Montserrat, sans-serif',
              }}
            >
              {sign}
            </Typography>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          borderTop: '1px solid #808080',
          width: '100%',
          pt: { xs: '12px', md: '16px' },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '12px', md: '14px' },
            textAlign: 'center',
            fontWeight: 400,
            color: '#808080',
            fontFamily: 'Montserrat, sans-serif',
          }}
        >
          Processamento seguro | Parceria BBMNET + ASAS Garantias
        </Typography>
      </Box>
    </Box>
  );
};

export default NoLimitIndicator;
